import React from 'react';
import { SectionReveal } from './ui/SectionReveal';
import { Button } from './ui/Button';
import { useLanguage } from '../context/LanguageContext';
type PhaseKey = 'p1' | 'p2' | 'p3' | 'p4';
type StatusKey = 'sold' | 'available' | 'soon';
type BtnKey = 'viewProject' | 'viewAvailable' | 'notify';
const phases: Array<{
  key: PhaseKey;
  statusKey: StatusKey;
  statusColor: string;
  dotColor: string;
  btnKey: BtnKey;
  btnVariant: 'primary' | 'secondary';
}> = [{
  key: 'p1',
  statusKey: 'sold',
  statusColor: 'bg-red-100 text-red-800',
  dotColor: 'bg-red-500',
  btnKey: 'viewProject',
  btnVariant: 'secondary'
}, {
  key: 'p2',
  statusKey: 'available',
  statusColor: 'bg-green-100 text-green-800',
  dotColor: 'bg-green-500',
  btnKey: 'viewAvailable',
  btnVariant: 'primary'
}, {
  key: 'p3',
  statusKey: 'soon',
  statusColor: 'bg-orange-100 text-orange-800',
  dotColor: 'bg-orange-500',
  btnKey: 'notify',
  btnVariant: 'secondary'
}, {
  key: 'p4',
  statusKey: 'soon',
  statusColor: 'bg-orange-100 text-orange-800',
  dotColor: 'bg-orange-500',
  btnKey: 'notify',
  btnVariant: 'secondary'
}];
export function PhasesSection() {
  const {
    t
  } = useLanguage();
  const scrollTo = (href: string) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <SectionReveal id="fases" className="bg-light" data-id="element-304">
      <div className="container mx-auto px-6 md:px-12" data-id="element-305">
        <div className="text-center mb-12" data-id="element-306">
          <span className="inline-block text-nature text-sm font-semibold tracking-[0.2em] uppercase mb-4" data-id="element-307">
            {t.phases.tag}
          </span>
          <h2 className="text-4xl md:text-5xl font-serif text-navy mb-5" data-id="element-308">
            {t.phases.title}
          </h2>
          <div className="w-20 h-[2px] bg-sand mx-auto" data-id="element-309"></div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 max-w-5xl mx-auto" data-id="element-310">
          {phases.map((phase, index) => <div key={index} className="group relative bg-[#5b82b8] text-white p-4 rounded-xl shadow-lg flex flex-col h-full overflow-hidden transition-transform duration-300 hover:-translate-y-1" data-id="element-311">
              {/* Large faded phase number */}
              <span aria-hidden="true" className="absolute -top-2 right-2 text-[3.5rem] font-serif font-bold leading-none text-white/5 select-none" data-id="element-312">
                {index + 1}
              </span>

              <h3 className="relative text-lg font-serif font-bold mb-3 text-white" data-id="element-313">
                {t.phases.phases[phase.key].name}
              </h3>

              <div className="relative space-y-3 flex-grow" data-id="element-314">
                <div data-id="element-315">
                  <p className="text-[10px] uppercase tracking-wider text-white/50 mb-1.5" data-id="element-316">
                    {t.phases.labels.status}
                  </p>
                  <div className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-[11px] font-bold ${phase.statusColor}`} data-id="element-317">
                    <div className={`w-1.5 h-1.5 rounded-full ${phase.dotColor}`} data-id="element-318"></div>
                    {t.phases.status[phase.statusKey]}
                  </div>
                </div>

                <div data-id="element-319">
                  <p className="text-[10px] uppercase tracking-wider text-white/50 mb-0.5" data-id="element-320">
                    {t.phases.labels.delivery}
                  </p>
                  <p className="text-sm font-medium text-white" data-id="element-321">
                    {t.phases.phases[phase.key].delivery}
                  </p>
                </div>
              </div>

              <div className="relative mt-4 pt-3 border-t border-white/10" data-id="element-322">
                <Button variant={phase.btnVariant} className="w-full" onClick={() => scrollTo(phase.statusKey === 'available' ? '#disponibilidad' : '#contacto')} data-id="element-323">
                  {t.phases.buttons[phase.btnKey]}
                </Button>
              </div>
            </div>)}
        </div>
      </div>
    </SectionReveal>;
}